import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	Output,
	ViewChild
} from "@angular/core";
import { ContactField } from "@models";
import { TranslationService } from "@core-services/translation.service";
import { empty } from "@helpers/utils";

@Component({
	selector: "contact-address-list-item",
	templateUrl: "./contact-address-list-item.component.html",
	styleUrls: ["./contact-address-list-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ContactAddressListItemComponent implements AfterViewInit {
	@Input() public icon: string = "";
	@Input() public address: ContactField = null;
	@Output() public onSend: EventEmitter<void> = new EventEmitter<void>();

	@ViewChild("details") public details: ElementRef;

	public _isOpen: boolean = false;
	private timeout: ReturnType<typeof setTimeout> = null;

	public constructor(
		private translationService: TranslationService,
		private readonly changeDetectorRef: ChangeDetectorRef
	) {}

	public ngAfterViewInit(): void {
		if (this.details) {
			this.details.nativeElement.addEventListener("mouseover", () => {
				clearTimeout(this.timeout);
				this._isOpen = true;
				this.changeDetectorRef.markForCheck();
			});
			this.details.nativeElement.addEventListener("mouseout", () => {
				this.timeout = setTimeout(() => {
					this._isOpen = false;
					this.changeDetectorRef.markForCheck();
				}, 300);
			});
		}
	}

	public isEmailAddress(): boolean {
		return this.address.getType() === "email";
	}

	public isMultiSignature(): boolean {
		return !!this.address.destination_tag;
	}

	public getAddressLabel(): string {
		if (this.isEmailAddress()) {
			return this.translationService.translate("email");
		}
		if (!empty(this.address.getName())) {
			return this.address.getName();
		}
		return this.address.getSymbol() + " " + this.translationService.translate("address");
	}

	public send(): void {
		this.onSend.emit();
	}
}
